import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GoalProgressCard = ({ goal, onModify, onView }) => {
  const getProgressColor = (progress) => {
    if (progress >= 75) return 'bg-success';
    if (progress >= 50) return 'bg-primary';
    if (progress >= 25) return 'bg-warning';
    return 'bg-error';
  };

  const getPriorityBadge = (priority) => {
    const styles = {
      high: 'bg-error/10 text-error border-error/20',
      medium: 'bg-warning/10 text-warning border-warning/20',
      low: 'bg-muted text-muted-foreground border-border'
    };
    return styles?.[priority] || styles?.low;
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 hover:shadow-card transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={goal?.icon} size={24} className="text-primary" />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-foreground">{goal?.name}</h4>
            <p className="text-sm text-muted-foreground">{goal?.category}</p>
          </div>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getPriorityBadge(goal?.priority)}`}>
          {goal?.priority?.charAt(0)?.toUpperCase() + goal?.priority?.slice(1)} Priority
        </span>
      </div>
      <div className="space-y-3 mb-4">
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Target Amount</span>
          <span className="text-sm font-semibold text-foreground">{goal?.targetAmount}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Current Savings</span>
          <span className="text-sm font-semibold text-foreground">{goal?.currentSavings}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Timeline</span>
          <span className="text-sm font-semibold text-foreground">{goal?.timeline}</span>
        </div>
      </div>
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-foreground">Progress</span>
          <span className="text-sm font-semibold text-foreground">{goal?.progress}%</span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full ${getProgressColor(goal?.progress)} transition-all duration-500`}
            style={{ width: `${goal?.progress}%` }}
          />
        </div>
      </div>
      {goal?.nextMilestone && (
        <div className="bg-muted/50 rounded-lg p-3 mb-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Flag" size={16} className="text-primary" />
            <span className="text-xs font-medium text-foreground">Next Milestone</span>
          </div>
          <p className="text-sm text-muted-foreground">{goal?.nextMilestone}</p>
        </div>
      )}
      <div className="flex gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          iconName="Eye" 
          iconPosition="left"
          onClick={() => onView(goal?.id)}
          className="flex-1"
        >
          View Details
        </Button>
        <Button 
          variant="default" 
          size="sm" 
          iconName="Edit" 
          iconPosition="left"
          onClick={() => onModify(goal?.id)}
          className="flex-1"
        >
          Modify
        </Button>
      </div>
    </div>
  );
};

export default GoalProgressCard;